import { useState } from 'react';
import { Box, IconButton, Typography, MenuIcon, UserAvatar, InfoOutlinedIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';

import ChatInfoModal from './chat-info-modal';

export default function ChatWindowHeader({ userId, chat, toggleSidebar, isAIChat, userHasUnreadChats }) {
    const isMobile = useIsMobile();

    const [displayInfoModal, setDisplayInfoModal] = useState(false);
    
    return (<>
        <Box 
            sx={{
                display: 'flex',
                alignItems: 'center',
                borderBottom: '1px solid #e0e0e0',
                px: isMobile ? 0 : 6,
                pb: 2
            }}>

            {isMobile && (
                <Box sx={{ position: "relative", display: "inline-block" }}>
                    <IconButton onClick={toggleSidebar} sx={{ mr: 1 }}>
                        <MenuIcon />
                    </IconButton>

                    {userHasUnreadChats && (
                        <Box
                            sx={{
                            position: "absolute",
                            top: 6,
                            right: 12,
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            bgcolor: "secondary.main", 
                            }}
                        />
                    )}
                </Box>
            )}

            <Box sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                px: isMobile ? 0 : 3
            }}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>                
                    <UserAvatar user={{
                        id: userId,
                        name: chat?.chatName,
                        profileImageUrl: chat?.chatImageUrl
                    }} />
                    <Typography variant="h5" ml={1}>{chat?.chatName}</Typography>
                </Box>
                <IconButton 
                    size="small" 
                    disableRipple 
                    sx={{mr: isMobile ? 2 : 0}}
                    onClick={() => setDisplayInfoModal(true)}>
                    <InfoOutlinedIcon />
                </IconButton>
            </Box>

        </Box>

        {displayInfoModal && (
            <ChatInfoModal 
                chatId={chat?.id}
                isAIChat={isAIChat}
                onClose={() => setDisplayInfoModal(false)} />
        )}
        
    </>);
};
